import { Typography, Grid, Box, keyframes, Stack } from "@mui/material";


const borderColorChange = keyframes`
  0% {
    border-color: #43B4B9;
  }
  33% {
    border-color: #596035;
  }
  66% {
    border-color: #562984;
  }
  100% {
    border-color: #43B4B9;
  }
`;


const colorChange = keyframes`
  0% {
    color: #43B4B9;
  }
  33% {
    color: #596035;
  }
  66% {
    color: #562984;
  }
  100% {
    color: #43B4B9; 
  }
`;

const ChangeLog = () => {

  return (
    <Box m="20px">

      <Box
        position="sticky"
        top={0}
        zIndex={10}
        backgroundColor="rgba(30, 30, 30, 0.6)"
        backdropFilter="blur(6px)"
        p={4}
        borderRadius="16px"
        mb={2}
        sx={{
          height: "120px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}

      >
        <img
          src="/logoWhite.png"
          alt="LECS"
          style={{ height: 50, width: "auto" }}
        />
        <Typography variant="h2" fontWeight={900} color="#459296">
          <span style={{ color: "#FFFFFF" }}>Evolution Through Versions</span>
        </Typography>
      </Box>
      {window.innerWidth > 1024 ? (
        <Box
          display="grid"
          marginTop={3}
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="130px"
          gap="10px"
        >

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
              <img
                src="/update_6.5.png"
                alt="Update 6.5"
                style={{height: 270, marginLeft: -24, borderRadius: 5}}
              />
            </Box>
            <Stack direction={"column"} spacing={3} alignItems={"left"} justifyContent={"center"}>
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 05/11/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296" sx={{ color: "#459296" }}>
                New Release Version 6.5.0
              </Typography>
              <Typography variant="h4">
                This update adds a right-click options menu to the SecurityLog tables, introduces a refreshed UI design for the Tiresia and Lecs Management pages, and includes a review of the functionalities in the Lecs Management section.
              </Typography>
            </Stack>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
              <img
                src="/update_6.1.png"
                alt="Update 6.1"
                style={{height: 270, marginLeft: -24, borderRadius: 5}}
              />
            </Box>
            <Stack direction={"column"} spacing={3} alignItems={"left"} justifyContent={"center"}>
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Mini Update | 20/10/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296" sx={{ color: "#459296" }}>
                New Release Version 6.1.0
              </Typography>
              <Typography variant="h4">
                We removed the heatmap view when opening a detail and added the ability to copy the detail directly to the clipboard.              
              </Typography>
            </Stack>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
              <img
                src="/update_6.0.png"
                alt="Update 6.0"
                style={{height: 270, marginLeft: -24, borderRadius: 5}}
              />
            </Box>
            <Stack direction={"column"} spacing={3} alignItems={"left"} justifyContent={"center"}>
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 14/10/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296" sx={{ color: "#459296" }}>
                New Release Version 6.0.0
              </Typography>
              <Typography variant="h4" sx={{whiteSpace: "pre-line"}}>
                In this update, Added support for multiple authenticator systems (TOTP-based). Users can now choose their preferred authentication method, improving both security and login speed.
              </Typography>
            </Stack>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="250px"
          >
            <Stack direction={"column"} spacing={3} alignItems={"left"} justifyContent={"center"}>
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 23/09/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296" sx={{ color: "#459296" }}>
                Bug Fixed & Improvements Version 5.7.0
              </Typography>
              <Typography variant="h4" sx={{whiteSpace: "pre-line"}}>
                UI/UX: Improved the look and clarity of several pages, making filters easier to read and use—especially in the SecurityLog section.{"\n"}
                Feature: You can now filter internal and external IP addresses more easily within SecurityLog.{"\n"}
                Fix: Fixed a few minor bugs to improve stability and overall experience.
              </Typography>
            </Stack>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="\last_update_visual_hd.png"
                alt="Update_5.2.7"
                style={{ width: 400, borderRadius: 5, marginLeft: -24, height: 270 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Weekly Report Update | 23/04/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 5.5.6
              </Typography>
              <Typography variant="h4">
              In this release, LECS automatically generates a weekly activity
              report in PDF format. The report provides a summary of key events and 
              system behavior, and will be available every Friday to support monitoring and analysis efforts.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="\latest_filters.png"
                alt="Update_5.2.7"
                style={{ width: 400, borderRadius: 5, marginLeft: -24, height: 270 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 17/04/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 5.5.1
              </Typography>
              <Typography variant="h4">
                In this version, we've significantly improved the filtering experience within the visualizer: filters are now more responsive, intuitive, and powerful. We've also introduced support for logical operators (AND/OR),
                allowing more flexible and advanced combinations of search criteria.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="\flags_up.png"
                alt="Flags"
                style={{
                  width: 300, borderRadius: 5, marginLeft: -24,
                  height: 200
                }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Mini Update | 21/03/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Improvements Version 5.4.0
              </Typography>
              <Typography variant="h4">
                We've added little <strong>flags 🌍</strong> next to IP addresses to help you instantly recognize their country of origin.
                You'll also see clearer indicators for the protocols in use, so it's easier than ever to understand what kind of traffic you're looking at a glance.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 11/03/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed & Improvements Version 5.3.0
              </Typography>
              <Typography variant="h4">
                This update brings better control over offline LECS devices, giving you more clarity and reliability when monitoring their status
                We've also fixed some bugs under the hood to improve overall stability
                And to top it off, we've made several interface tweaks to give you more visibility into what matters most.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="\update_5-2-7.png"
                alt="Update_5.2.7"
                style={{ width: 400, borderRadius: 5, marginLeft: -24, height: 270 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 19/02/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 5.2.7
              </Typography>
              <Typography variant="h4">
                Version 5.2.7 brings some exciting updates designed to make your work even easier
                You can now filter data by subnet, focus on specific time ranges, and combine multiple conditions using AND or OR logic to get exactly the insights you need
                Tires-IA is now more conversational and intuitive, better at understanding your questions and guiding you step by step through data analysis
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 13/02/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed & Improvements Version 5.1.1
              </Typography>
              <Typography variant="h4">
                After the release of version 5.0.0, we have resolved several bugs that affected the previous update.
                Additionally, the Real-Time Transmission data now correctly displays the units of measurement (such as MB, GB, etc.), ensuring more accurate and consistent readings.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            border="solid 3px "
            sx={{ animation: `${borderColorChange} 3s linear infinite` }}
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/5.0.0.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 480, borderRadius: 5, marginLeft: -50, height: 260 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 11/02/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 5.0.0 Tires-IA UPDATE
              </Typography>
              <Typography variant="h4">
                BIG UPDATE:
                This release brings major new features to Tiresias and its visualization capabilities.
                You can now use the AI on each page to customize the view and extract key logs, providing more control and insight.
                Additionally, the Tiresia-AI page has been completely revamped to better showcase the full power of the engine, enhancing its usability and performance.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 27/01/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 4.7.14
              </Typography>
              <Typography variant="h4">
                Fixed critical stability issues and improved responsiveness under heavy load.
                Enhanced system feedback and UI fluidity for better interaction.
                Optimized backend processes for smoother operations.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 20/01/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 4.5.1
              </Typography>
              <Typography variant="h4">
                Resolved minor bugs and improved layout consistency.
                Navigation is now more intuitive and fluid.
                Reduced memory usage during active sessions.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 16/01/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 4.3.2
              </Typography>
              <Typography variant="h4">
                Fixed UI glitches and improved resolution handling.
                Reduced latency during peak hours.
                Overall user experience is now more consistent.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed |11/01/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 4.1.7
              </Typography>
              <Typography variant="h4">
                Stabilized background processes and async tasks.
                Improved accessibility and visual clarity.
                Enhanced data processing under frequent load.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/4.0.0.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 500, height: 600, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 20/12/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 4.0.0
              </Typography>
              <Typography variant="h4">
                v 4.0.0 introduces a completely renewed interface, new tools, and an enhanced user experience.
                Dive into the full dark-style environment of LECS, redesigned to be more immersive, modern, and intuitive.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.4.3.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 13/12/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.4.3
              </Typography>
              <Typography variant="h4">
                v 3.4.3 introduces dedicated ticketing for LECS hardware issues and a new Protocol Analyzer in the IP search view.
                Includes general bug fixes, improved speed, and an enhanced user experience.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 5/12/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.4.2
              </Typography>
              <Typography variant="h4">
                Resolved several backend inconsistencies and improved responsiveness during session transitions.
                Minor UI adjustments contribute to a smoother and more reliable user experience.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 1/12/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.4.1
              </Typography>
              <Typography variant="h4">
                Fixed isolated bugs affecting search performance and log rendering.
                Enhanced interface stability and slightly improved load times across views.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.4.0.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 25/11/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.4.0
              </Typography>
              <Typography variant="h4">
                v 3.4.0 introduces a redesigned interface with new menus and features focused on simplifying the user experience.
                Log readability has been enhanced, and the HighLights view now clearly distinguishes internal and external logs.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 19/11/2025
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.3.15
              </Typography>
              <Typography variant="h4">
                Minor bug fixes and subtle UX improvements to ensure a smoother and more stable experience.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 12/11/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.3.14
              </Typography>
              <Typography variant="h4">
                Fixed small issues and refined some interface behaviors for better usability and consistency.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.13.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 5/11/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.3.13
              </Typography>
              <Typography variant="h4">
                v 3.3.13 New feature added: New log control setting,
                now you can disable device response in case of high and critical attacks or
                manually suppress display and notifications for detection logs.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 1/11/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.3.12
              </Typography>
              <Typography variant="h4">
                This version only adds a few bug fixes and improves the User Experience
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.11.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 27/10/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.3.11
              </Typography>
              <Typography variant="h4">
                Viewing all your LECS is now easier thanks to a new dedicated section.
                Get a quick and meaningful overview of each device — all in one place.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.10.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 18/10/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.3.10
              </Typography>
              <Typography variant="h4">
                You can now access detailed information about IPs shown on the map.
                We've also introduced a more accurate and optimized network calculation, with richer insights.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 13/10/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.3.9
              </Typography>
              <Typography variant="h4">
                This update focuses solely on bug fixes and maintenance improvements.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.8.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 680, borderRadius: 5, marginLeft: -160, height: 600 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 12/10/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.3.8
              </Typography>
              <Typography variant="h4">
                A new real-time graph has been added to the Transmission section,
                showing your BPS trend over the last 48 hours.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.6.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 8/10/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.3.6
              </Typography>
              <Typography variant="h4">
                Real-Time Transmission now shows max/min values for both BpS and PpS.
                Hostnames (if available) are now visible in the Online Hosts table under Status.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.5.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 2/10/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.3.5
              </Typography>
              <Typography variant="h4">
                User Settings now support up to two secondary accounts,
                each with customizable LECS access permissions.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 29/9/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.3.4
              </Typography>
              <Typography variant="h4">
                This version includes minor bug fixes to improve overall system stability.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.1.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 22/9/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.3.1
              </Typography>
              <Typography variant="h4">
                Tires-IA now generates a fully AI-driven page that analyzes your logs and highlights the most unusual ones.
                Results are displayed in a table alongside a 3D scatter plot for intuitive visual exploration.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 18/9/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.2.26
              </Typography>
              <Typography variant="h4">
                This update includes minor bug fixes to ensure greater system stability.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 11/9/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.2.19
              </Typography>
              <Typography variant="h4">
                Applied general bug fixes and optimized data handling for improved performance and efficiency.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.2.17.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 3/9/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.2.17
              </Typography>
              <Typography variant="h4">
                By popular demand, a new set of short tutorials has been released — tailored for each
                available page to guide you through key features.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 30/8/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.2.15
              </Typography>
              <Typography variant="h4">
                Applied minor bug fixes to maintain stability and reliability.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 2/8/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.2.11
              </Typography>
              <Typography variant="h4">
                General bug fixes and improved internal data handling for better performance.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 25/7/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.2.9
              </Typography>
              <Typography variant="h4">
                Resolved interface issues and enhanced the overall user experience.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 21/7/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.2.5
              </Typography>
              <Typography variant="h4">
                This update includes small bug fixes to ensure smoother operation.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.0.1.1.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 12/7/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.1.1
              </Typography>
              <Typography variant="h4">
                v 3.1.1 introduces the new Search by IP tool.
                Select any IP detected by LECS and explore related actions through detailed graphs and tables, including host interactions, ports, and full connection paths.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 28/6/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.0.12
              </Typography>
              <Typography variant="h4">
                This version only adds some bug fixes and Improved user experience
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 13/6/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.0.10
              </Typography>
              <Typography variant="h4">
                This version only adds some bug fixes
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.0.7.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 2/6/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.0.7
              </Typography>
              <Typography variant="h4">
                v 3.0.7 introduces a new system for reading and managing notifications, designed to improve clarity and control over alerts.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 27/5/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.0.5
              </Typography>
              <Typography variant="h4">
                Applied bug fixes and added detailed explanations by Tires-IA for each log, improving interpretability.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
            height="200px"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Bug Fixed | 16/5/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.0.2
              </Typography>
              <Typography variant="h4">
                This update includes minor bug fixes to ensure system stability and reliability.
              </Typography>
            </Box>
          </Box>

          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3_0_0_1.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 450, borderRadius: 5, marginLeft: -22 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography fontWeight={100} variant="h5">
                <span style={{ fontWeight: 700 }}>LECS</span> Update | 3/5/2024
              </Typography>
              <Typography variant="h3" fontWeight={900} color="#459296"
                sx={{ animation: `${colorChange} 6s infinite` }}>
                New Release Version 3.0.1
              </Typography>
              <Typography variant="h4">
                Dashboard v3.0.1 features a new dark style and redesigned visuals across core components.
                The map has been replaced with a 3D Globe, offering a modern and fully reworked user interaction experience.
              </Typography>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Grid container spacing={2}>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid xs={12} md={12} display="flex" alignItems="center" justifyContent="center">
                  <img
                    src="/3.3.8.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: 550, borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                  xs={12} md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.3.8
                  </Typography>
                  <Typography variant="h4">
                    v 3.3.8 New Graph in Real Time Transmission section released, now you can see your bps over the last 48 hrs.
                  </Typography>
                </Grid>
              </Grid>\rwedv
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.3.7
                  </Typography>
                  <Typography variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* <Box
          display="grid"
          marginTop={3}
          gridTemplateColumns="repeat(12, 1fr)"
          gridAutoRows="120px"
          gap="20px"
        >
          <Box
            gridColumn="span 12"
            gridRow="span 2"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box display="flex" alignItems="center" justifyContent="center">
              <img
                src="/3.3.8.svg"
                alt="SelectedDeleteLecs Icon"
                style={{ width: 550, borderRadius: 5 }}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography variant="h3" fontWeight={900} color="#459296">
                New Release Version 3.3.8
              </Typography>
              <Typography fontWeight={600} variant="h4">
                v 3.3.8 New Graph in Real Time Transmission section released, now you can see your bps over the last 48 hrs.
              </Typography>
            </Box>
          </Box>
          <Box
            gridColumn="span 5"
            gridRow="span 1"
            backgroundColor={"#1e1e1e"}
            display="flex"
            borderRadius="10px"
            p={3}
            gap={2}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="left"
              justifyContent="center"
              gap={3}
            >
              <Typography variant="h3" fontWeight={900} color="#459296">
                Bug Fixed Version 3.3.7
              </Typography>
              <Typography fontWeight={600} variant="h4">
                This version only adds some bug fixes
              </Typography>
            </Box>
          </Box>*/}
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid xs={12} md={12} display="flex" alignItems="center" justifyContent="center">
                  <img
                    src="/3.3.6.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                  xs={12} md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.3.6
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    v 3.3.6 You will now have the maximum and minimum available in
                    the Real Time Transmission section for both BpS and PpS; also,
                    you will be able to see the host name (if available), in the
                    Online Hosts table in the Status section
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="sticky"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src="/3.3.5.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ maxWidth: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.3.5
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    New Release Version 3.3.5
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    {" "}
                    Now in the User Settings you will have the ability to enter
                    up to 2 secondary accounts and associate their allowed lecs
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.3.4
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 2 */}
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src="/3.3.1.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.3.1
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    In v 3.3.1 Tires-IA will employ its computational power to
                    offer you a page totally created by it, analyzing all your
                    logs and trying to figure out which ones are the strangest,
                    then showing them to you in a table flanked by a
                    three-dimensional Scatter Plot.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.2.26
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 3 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.2.19
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes and Optimized data
                    management
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src="/3.2.17.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.2.17
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    v 3.2.17 By popular demand, we decided to release a small
                    explanatory tutorial, customized for each available page
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 4 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.2.15
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.2.11
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes and Optimized data
                    management
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 5 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.2.9
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes and Improved user
                    experience
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.2.5
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 6 */}
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src="/3.2.4.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.2.4
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    Now in Device Settings you can set your time zone, which
                    will format the times in most of the other tables
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 7 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.2.2
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src="/3.1.17.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.2.1
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    In v 3.2.1 you will have the Advanced Visualizer, a tool for
                    you to be able to analyze all your data and see its progress
                    over a 60-day range, you will have the ability to apply
                    various filters, and you will be able to track the change or
                    addition of logs within 3 days chosen by you.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 8 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.1.8
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some system bug fixes and graphical
                    bugs{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.1.4
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes and Improved user
                    experience{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 9 */}
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src="/3.0.1.1.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.1.1
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    v 3.1.1 introduces a new tool called Search by IP. Here you
                    can choose an IP from those detected by LECS in your
                    network, then you will have graphs and table showing the
                    actions and behaviors related to that IP. You will be able
                    to make use of an interesting graph where you will visualize
                    the various contacts between the host of the chosen ip and
                    other hosts, and you will have the possibility to go even
                    deeper to the connection, visualizing ports and every
                    movement.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                container
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.0.12
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 10 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.0.10
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.0.7
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    v 3.0.7 New Reading and Notification Management system
                    released.{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 11 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.0.5
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes, and Added explanation
                    of Tires-IA for each LOG.{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    New Release Version 3.0.2
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    This version only adds some bug fixes
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* ROW 12 */}
            <Grid xs={12} md={12}>
              <Grid
                backgroundColor={"#1e1e1e"}
                display="flex"
                borderRadius="10px"
                p={3}
                gap={2}
              >
                <Grid
                                    xs={12}
                  md={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <img
                    src="/3_0_0_1.svg"
                    alt="SelectedDeleteLecs Icon"
                    style={{ width: "100%", borderRadius: 5 }}
                  />
                </Grid>
                <Grid
                  display="flex"
                  flexDirection="column"
                  alignItems="left"
                  justifyContent="center"
                  gap={3}
                >
                  <Typography variant="h3" fontWeight={900} color="#459296">
                    Bug Fixed Version 3.0.1
                  </Typography>
                  <Typography fontWeight={600} variant="h4">
                    Dashboard v.3.0.1 comes with a dark style and graphical
                    renovations of old features, especially the new map, now
                    represented by a 3D Globe, equipped with a totally renewed
                    and modern user feedback
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
      */
    </Box>
  );
};

export default ChangeLog;
